import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaUser, FaTags, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaMicrophone, FaFileAlt, FaVideo, FaHandshake, FaClipboardCheck } from 'react-icons/fa';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'event signup':
      return <FaClipboardCheck />; // Clipboard Check icon

    case 'event schedule':
      return <FaCalendarAlt />; // Calendar Alt icon

    case 'attendee networking':
      return <FaHandshake />; // Handshake icon

    case 'speaker info':
      return <FaMicrophone />; // Microphone icon

    case 'live access':
      return <FaVideo />; // Video icon

    case 'event materials':
      return <FaFileAlt />; // File Alt icon

    /*----- Page Sidebar -----*/
    case 'eventtype':
    case 'category':
      return <FaTags />; // Tags icon representing event type or category

    case 'date':
      return <FaCalendarAlt />; // Calendar icon representing the event date

    case 'time':
      return <FaClock />; // Clock icon representing event time

    case 'client':
      return <FaUser />; // User icon representing the client

    case 'venue':
      return <FaMapMarkerAlt />; // Map Marker icon representing the event location

    case 'attendees':
      return <FaUsers />; // Users icon representing the number of attendees

    case 'speakers':
      return <FaMicrophone />; // Microphone icon representing event speakers

    case 'organizer':
      return <FaUserTie />; // User Tie icon representing the event organizer

    case 'number':
      return <FaPhone />; // Phone icon representing the contact number

    case 'email':
      return <FaEnvelope />; // Envelope icon representing the email address

    case 'entryfee':
      return <FaDollarSign />; // Dollar sign icon representing entry fee/payment

    default:
      return null; // Return null if no matching icon is found

  }

};